const GET_ALL_EXPERTISE_REQUEST = "GET_ALL_EXPERTISE_REQUEST";
const GET_ALL_EXPERTISE_COMPLETE = "GET_ALL_EXPERTISE_COMPLETE";
const GET_ALL_EXPERTISE_ERROR = "GET_ALL_EXPERTISE_ERROR";

export default {
  GET_ALL_EXPERTISE_REQUEST,
  GET_ALL_EXPERTISE_COMPLETE,
  GET_ALL_EXPERTISE_ERROR
}
